import React from "react";
import ShareCardPreview from "../Common/v2/ShareCardPreview";
import "./GitchaSyndicateConfirm.scss";

const GitchaSyndicateConfirm = ({ listing, onConfirm, onCancel }) => {
  return (
    <div className="gitcha-confirm">
      <div className="gitcha-confirm__stage">
        <div className="gitcha-confirm__share">
          <ShareCardPreview adDetails={listing} isSideCard />
        </div>
      </div>
      <div className="gitcha-confirm__copy">
        <h2 className="gitcha-confirm__title">
          Syndicate to <b className="gitcha-brand">Gitcha.com</b>
        </h2>
        <p className="gitcha-confirm__text">
          Your branding is featured on the public page and share&nbsp;card. You
          can stop syndicating at any&nbsp;time.
        </p>
      </div>
      <div className="gitcha-confirm__actions">
        <button
          type="button"
          className="gitcha-confirm__btn gitcha-confirm__btn--primary"
          onClick={onConfirm}
        >
          Syndicate
        </button>
        <button type="button" className="gitcha-confirm__btn" onClick={onCancel}>
          Cancel
        </button>
      </div>
    </div>
  );
};

export default GitchaSyndicateConfirm;
